export default __webpack_public_path__ + "static/media/banner_luyen_tap.eacbc5c6.png";